<template>
  <div class="page-container">
    <el-tabs v-model="tab"
      ><el-tab-pane label="省区管理" name="region"
        ><div class="toolbar">
          <el-button class="primary" @click="editRegion()">新增省区</el-button
          ><span>经理统一在业务分组中调整</span>
        </div>
        <el-table :data="regions" v-loading="loading" class="business-list-table" stripe
          ><el-table-column label="序号" width="68"><template slot-scope="{ $index }"><span class="list-index">{{ $index + 1 }}</span></template></el-table-column><el-table-column
            prop="region_code"
            label="省区编码"
          /><el-table-column
            prop="region_name"
            label="省区名称"
          /><el-table-column label="关联分组"
            ><template slot-scope="{ row }"
              ><span v-if="row.group_name">{{ row.group_name }}</span
              ><el-tag v-else size="mini" type="info">未分组</el-tag></template
            ></el-table-column
          ><el-table-column label="经理"
            ><template slot-scope="{ row }">{{
              row.group_manager_name || "—"
            }}</template></el-table-column
          ><el-table-column
            prop="personnel_count"
            label="人员数"
            width="90"
          /><el-table-column
            prop="hospital_count"
            label="医院数"
            width="90"
          /><el-table-column label="操作" width="80"
            ><template slot-scope="{ row }"
              ><el-button type="text" @click="editRegion(row)"
                >编辑</el-button
              ></template
            ></el-table-column
          ></el-table
        ></el-tab-pane
      ><el-tab-pane label="业务分组" name="group"
        ><div class="toolbar">
          <el-button class="primary" @click="editGroup()">新增分组</el-button
          ><span>一个分组可包含多个省区，同一省区可加入多个分组</span>
        </div>
        <el-table :data="groups" v-loading="loading" class="business-list-table" stripe
          ><el-table-column label="序号" width="68"><template slot-scope="{ $index }"><span class="list-index">{{ $index + 1 }}</span></template></el-table-column><el-table-column
            prop="group_code"
            label="分组编码"
          /><el-table-column
            prop="group_name"
            label="分组名称"
          /><el-table-column prop="manager_name" label="经理" /><el-table-column
            prop="region_count"
            label="省区数"
            width="90"
          /><el-table-column label="包含省区"
            ><template slot-scope="{ row }">{{
              (row.region_names || []).join("、") || "—"
            }}</template></el-table-column
          ><el-table-column label="状态" width="80"
            ><template slot-scope="{ row }">{{
              row.status === "ACTIVE" ? "启用" : "停用"
            }}</template></el-table-column
          ><el-table-column label="操作" width="80"
            ><template slot-scope="{ row }"
              ><el-button type="text" @click="editGroup(row)"
                >编辑</el-button
              ></template
            ></el-table-column
          ></el-table
        ></el-tab-pane
      ></el-tabs
    >
    <el-dialog
      :title="regionForm.sjid ? '编辑省区' : '新增省区'"
      :visible.sync="regionVisible"
      width="620px"
      custom-class="business-edit-dialog"
      ><el-form
        ref="regionForm"
        class="business-form"
        :model="regionForm"
        :rules="regionRules"
        label-position="top"
        ><el-row :gutter="18"
          ><el-col :span="12"
            ><el-form-item label="省区编码" prop="region_code"
              ><el-input
                v-model.trim="regionForm.region_code" /></el-form-item></el-col
          ><el-col :span="12"
            ><el-form-item label="省区名称" prop="region_name"
              ><el-input
                v-model.trim="
                  regionForm.region_name
                " /></el-form-item></el-col></el-row
        ><el-form-item label="上级省区"
          ><el-select v-model="regionForm.parent_id" clearable
            ><el-option
              v-for="r in regions.filter((x) => x.sjid !== regionForm.sjid)"
              :key="r.sjid"
              :label="r.region_name"
              :value="r.sjid" /></el-select></el-form-item
        ><el-form-item label="关联分组 / 经理"
          ><el-input
            :value="
              regionForm.group_name
                ? regionForm.group_name +
                  ' / ' +
                  (regionForm.group_manager_name || '—')
                : '未分组（请在业务分组中配置）'
            "
            disabled /></el-form-item
        ><el-form-item label="状态"
          ><el-select v-model="regionForm.status"
            ><el-option label="启用" value="ACTIVE" /><el-option
              label="停用"
              value="INACTIVE" /></el-select></el-form-item></el-form
      ><span slot="footer"
        ><el-button @click="regionVisible = false">取消</el-button
        ><el-button class="primary" :loading="saving" @click="saveRegion"
          >保存</el-button
        ></span
      ></el-dialog
    >
    <el-dialog
      :title="groupForm.sjid ? '编辑业务分组' : '新增业务分组'"
      :visible.sync="groupVisible"
      width="680px"
      custom-class="business-edit-dialog"
      ><el-form
        ref="groupForm"
        class="business-form"
        :model="groupForm"
        :rules="groupRules"
        label-position="top"
        ><el-row :gutter="18"
          ><el-col :span="12"
            ><el-form-item label="分组编码" prop="group_code"
              ><el-input
                v-model.trim="groupForm.group_code" /></el-form-item></el-col
          ><el-col :span="12"
            ><el-form-item label="分组名称" prop="group_name"
              ><el-input
                v-model.trim="
                  groupForm.group_name
                " /></el-form-item></el-col></el-row
        ><el-form-item label="经理"
          ><el-select
            v-model="groupForm.manager_user_id"
            clearable
            filterable
            style="width: 100%"
            ><el-option
              v-for="p in options.personnel"
              :key="p.sjid"
              :label="p.label"
              :value="p.sjid" /></el-select></el-form-item
        ><el-form-item label="管理省区"
          ><el-select
            v-model="groupForm.region_ids"
            multiple
            filterable
            style="width: 100%"
            ><el-option
              v-for="r in selectableRegions"
              :key="r.sjid"
              :label="r.region_name"
              :value="r.sjid" /></el-select></el-form-item
        ><el-row :gutter="18"
          ><el-col :span="12"
            ><el-form-item label="排序"
              ><el-input-number
                v-model="groupForm.sort_no"
                :min="0" /></el-form-item></el-col
          ><el-col :span="12"
            ><el-form-item label="状态"
              ><el-select v-model="groupForm.status"
                ><el-option label="启用" value="ACTIVE" /><el-option
                  label="停用"
                  value="INACTIVE" /></el-select></el-form-item></el-col></el-row></el-form
      ><span slot="footer"
        ><el-button @click="groupVisible = false">取消</el-button
        ><el-button class="primary" :loading="saving" @click="saveGroup"
          >保存并联动</el-button
        ></span
      ></el-dialog
    >
  </div>
</template>
<script>
import { organizationApi } from "../services/api";
const er = () => ({
  sjid: "",
  parent_id: "",
  region_code: "",
  region_name: "",
  region_level: 1,
  status: "ACTIVE",
});
const eg = () => ({
  sjid: "",
  group_code: "",
  group_name: "",
  manager_user_id: "",
  region_ids: [],
  status: "ACTIVE",
  sort_no: 0,
});
export default {
  data: () => ({
    tab: "region",
    loading: false,
    saving: false,
    regions: [],
    groups: [],
    options: { personnel: [] },
    regionForm: er(),
    groupForm: eg(),
    regionVisible: false,
    groupVisible: false,
    regionRules: {
      region_code: [{ required: true, message: "请输入省区编码" }],
      region_name: [{ required: true, message: "请输入省区名称" }],
    },
    groupRules: {
      group_code: [{ required: true, message: "请输入分组编码" }],
      group_name: [{ required: true, message: "请输入分组名称" }],
    },
  }),
  computed: {
    selectableRegions() {
      return this.regions;
    },
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const r = await Promise.all([
          organizationApi.listRegions(),
          organizationApi.listRegionGroups(),
          organizationApi.options(),
        ]);
        this.regions = r[0] || [];
        this.groups = r[1] || [];
        this.options = r[2] || { personnel: [] };
      } catch (e) {
        this.$message.error(e.message);
      } finally {
        this.loading = false;
      }
    },
    editRegion(row) {
      this.regionForm = Object.assign(er(), row || {});
      this.regionVisible = true;
    },
    editGroup(row) {
      this.groupForm = Object.assign(eg(), row || {}, {
        region_ids: ((row && row.region_ids) || []).slice(),
      });
      this.groupVisible = true;
    },
    saveRegion() {
      this.$refs.regionForm.validate(async (ok) => {
        if (!ok) return;
        this.saving = true;
        try {
          await organizationApi.saveRegion(this.regionForm);
          this.regionVisible = false;
          await this.load();
          this.$message.success("省区保存成功");
        } catch (e) {
          this.$message.error(e.message);
        } finally {
          this.saving = false;
        }
      });
    },
    saveGroup() {
      this.$refs.groupForm.validate(async (ok) => {
        if (!ok) return;
        if (
          this.groupForm.status === "ACTIVE" &&
          !this.groupForm.manager_user_id
        ) {
          this.$message.error("启用的业务分组必须选择经理");
          return;
        }
        this.saving = true;
        try {
          await organizationApi.saveRegionGroup(this.groupForm);
          this.groupVisible = false;
          await this.load();
          this.$message.success("业务分组保存成功");
        } catch (e) {
          this.$message.error(e.message);
        } finally {
          this.saving = false;
        }
      });
    },
  },
};
</script>
<style scoped>
.toolbar {
  display: flex;
  gap: 14px;
  align-items: center;
  margin-bottom: 18px;
}
.primary {
  color: #fff !important;
  background: #168fd1 !important;
  border-color: #168fd1 !important;
}
</style>
